export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-8" style={{ fontFamily: 'var(--font-heading)' }}>
            关于鲁鲁影院
          </h2>
          <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/60">
            <div className="flex flex-col md:flex-row items-center gap-8 md:gap-10">
              <div className="shrink-0 w-24 h-24 rounded-2xl bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-fill text-white text-3xl"></i>
              </div>
              <div className="flex-1">
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                  鲁鲁影院是一个致力于为影迷提供<strong>高清免费在线影视</strong>内容的平台。
                  我们深知每一位追剧爱好者对于画质和流畅度的追求，因此持续优化播放体验，
                  打造无需缓冲、无需付费的纯净观影环境。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  从最新上映的热门大片到经典不朽的高分佳作，从国产优质剧集到海外热播综艺，
                  鲁鲁影院每日更新海量资源，覆盖全类型题材。我们的编辑团队精心筛选每一部作品，
                  只为让你在繁忙生活中，拥有最轻松、最畅快的追剧时光。
                </p>
              </div>
            </div>
            <div className="mt-8 pt-8 border-t border-background-200/60 grid grid-cols-3 gap-4 text-center">
              <div>
                <div className="text-2xl font-bold text-primary-500" style={{ fontFamily: 'var(--font-heading)' }}>3万+</div>
                <div className="text-xs text-foreground-500 mt-1">在线片源</div>
              </div>
              <div>
                <div className="text-2xl font-bold text-primary-500" style={{ fontFamily: 'var(--font-heading)' }}>全类型</div>
                <div className="text-xs text-foreground-500 mt-1">题材覆盖</div>
              </div>
              <div>
                <div className="text-2xl font-bold text-primary-500" style={{ fontFamily: 'var(--font-heading)' }}>1080P</div>
                <div className="text-xs text-foreground-500 mt-1">高清画质</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}